module.exports = __webpack_public_path__ + "static/media/portfolio-website.96a00ca7.png";